import "./summary.css";
import Actions from "../Actions";
import { formatTurnDescription, formatLastActivity } from "../Game/scoreboardUtils";

const Summary = ({game, boardConfig, clearTilesFromBoard, tilesOnBoard, turn, play, isMyTurn, onExchange, onPass, onChallenge, canChallenge}) => {

    const lastActivity = () => {
        const playerCount = game.players?.length ?? 0;
        if (playerCount === 0) return "No activity yet";
        const lastPlayerIndex = (game.currentPlayer - 1 + playerCount) % playerCount;
        const lastRound = game.currentPlayer > 0 ? game.currentRound : game.currentRound - 1;
        const turn = game.scoreBoard.rounds[lastRound]?.turns[lastPlayerIndex];
        const playerName = game.players[lastPlayerIndex]?.name;
        return formatLastActivity(turn, playerName);
    };

    const lastTurn = (playerIndex) => {
        let round = (playerIndex < game.currentPlayer) ? game.currentRound : game.currentRound - 1;
        let turn = game.scoreBoard.rounds[round]?.turns[playerIndex];
        return turn || null;
    }

    return (
        <div className="summary">
            <div className="activity d-block">
                <h4>{game.name}</h4>
                <h6>{lastActivity()}<br/><span className="fw-bold">{game.bagCount}</span> tiles left</h6>
            </div>
            <div className="players row justify-content-center">
                {game?.players?.map((player, i) => (
                    <div key={`summaryPlayerMobile${i}`} >
                        {boardConfig === "mobile" ? 
                        <div className={`col-12 py-1  ${i === game.currentPlayer ? "yourTurn" : ""}`}>
                            <div className="d-flex justify-content-between">
                                <div className="fw-bold">{player.name} ({lastTurn(i)?.culmulativeScore ?? 0})
                                </div>
                                <div>rack ({game.rackCounts?.[i] ?? 0})</div>
                            </div>
                           
                            <div className="text-center">{formatTurnDescription(lastTurn(i))}</div>
                        </div> : 
                        <div className={`col-12 pb-2 ${i === game.currentPlayer ? "yourTurn" : ""}`}>
                            <div className="playerName text-center fw-bold fs-4">{player.name}</div>
                            <div className="playerStatus d-flex justify-content-between">
                                <div className="playerScore">
                                    <div className="playerScoreLabel text-center">score</div>
                                    <div className="playerScoreValue text-center fw-bold">{lastTurn(i)?.culmulativeScore ?? 0}</div>
                                </div>
                                <div className="playerLast">
                                    <div className="playerLastLabel text-center">last turn</div>
                                    <div className="playerLastValue text-center fw-bold">{formatTurnDescription(lastTurn(i))}</div>
                                </div>
                                <div className="playerRack">
                                    <div className="playerRackLabel text-center">rack</div>
                                    <div className="playerRackValue text-center fw-bold">{game.rackCounts?.[i] ?? 0}</div>
                                </div>
                            </div>
                        </div>}
                    </div>
                ))}
            </div>
            <div className="d-none d-lg-block"><Actions clearTilesFromBoard={clearTilesFromBoard} playedTileCount={tilesOnBoard} buttonSize="lg" turn={turn} play={play} isMyTurn={isMyTurn} playerCount={game.players?.length ?? 2} onExchange={onExchange} onPass={onPass} onChallenge={onChallenge} canChallenge={canChallenge}></Actions></div>
        </div>
    )
}

export default Summary;
